import React, { Component } from 'react';
import debounce from 'lodash/debounce';
import { func, array, string, number, oneOfType, bool, object } from 'prop-types';
import AdvancedTable from 'ps-components/AdvancedTable/AdvancedTable';
import AdvancedCell from 'ps-components/AdvancedTable/AdvancedCell';
import { MODEL_TYPE } from '../reducers/GradeListReducer';
import { applyRounding, parseNumCheckNull } from 'ps-components/lib/formatters';
import './StructureModelingAnalyticsTable.scss';

const columnHeaders = [
  { accessor: 'grade', Header: 'Grade', width: 136.8 },
  { accessor: 'p_job_count', Header: 'Total Jobs', rightAlign: true, width: 94.05 },
  { accessor: 'p_ee_count', Header: 'Total EEs', rightAlign: true, width: 94.05 },
  { accessor: 'p_below_min', Header: '# Below Min', rightAlign: true, width: 94.05 },
  { accessor: 'p_above_max', Header: '# Above Max', rightAlign: true, width: 94.05 },
  { accessor: 'p_cost_to_move_min', Header: 'Cost to Move to Min', rightAlign: true, width: 128.25 },
  { accessor: 'p_avg_comp_ratio', Header: 'Avg Compa-Ratio', rightAlign: true, width: 106.875 },
  { accessor: 'p_avg_range_pen', Header: 'Avg Range Pen', rightAlign: true, width: 106.875 }
];

export default class StructureModelingAnalyticsTable extends Component {
  static propTypes = {
    columnHeaders: array,
    smaData: array,
    clickGrade: oneOfType([bool, func]),
    modelId: oneOfType([number, string]),
    typeOfStructure: string,
    gradeListLoading: bool,
    gradeListError: bool,
    tfootData: object,
    isPdf: bool,
    basis: string,
    loadingGrade: bool
  };

  constructor(props) {
    super(props);
    this.getRowElement = this.getRowElement.bind(this);
  }

  getRowElement(rowData, idx) {
    const { preferences } = this.props;
    let isNew = this.props.typeOfStructure === MODEL_TYPE.NEW;
    let hasProps = !!rowData.cells;
    let rowDataObj = rowData.original || rowData;
    let jobEmployeeCounts = (
      <React.Fragment>
        <AdvancedCell
          getCellProps={hasProps ? rowData?.cells[1].getCellProps : null}
          className="sma--table__body-cell right-align"
        >
          <div className="current-proposed__container">
            {!isNew && <span className="current">{parseNumCheckNull(rowDataObj.c_job_count, true)}</span>}
            <span className="proposed">{parseNumCheckNull(rowDataObj.p_job_count, true)}</span>
          </div>
        </AdvancedCell>
        <AdvancedCell
          getCellProps={hasProps ? rowData?.cells[2].getCellProps : null}
          className="sma--table__body-cell right-align"
        >
          <div className="current-proposed__container">
            {!isNew && <span className="current">{parseNumCheckNull(rowDataObj.c_ee_count, true)}</span>}
            <span className="proposed">{parseNumCheckNull(rowDataObj.p_ee_count, true)}</span>
          </div>
        </AdvancedCell>
      </React.Fragment>
    );
    if (this.props.typeOfStructure === MODEL_TYPE.EXISTING) {
      jobEmployeeCounts = (
        <React.Fragment>
          <AdvancedCell
            getCellProps={hasProps ? rowData?.cells[1].getCellProps : null}
            className="sma--table__body-cell right-align"
          >
            {parseNumCheckNull(rowDataObj.p_job_count, true)}
          </AdvancedCell>
          <AdvancedCell
            getCellProps={hasProps ? rowData?.cells[2].getCellProps : null}
            className="sma--table__body-cell right-align"
          >
            {parseNumCheckNull(rowDataObj.p_ee_count, true)}
          </AdvancedCell>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <AdvancedCell getCellProps={hasProps ? rowData?.cells[0].getCellProps : null} className="sma--table__body-cell">
          {rowDataObj.grade}
        </AdvancedCell>
        {jobEmployeeCounts}
        <AdvancedCell
          getCellProps={hasProps ? rowData?.cells[3].getCellProps : null}
          className="sma--table__body-cell right-align"
        >
          <div className="current-proposed__container">
            {!isNew && <span className="current">{parseNumCheckNull(rowDataObj.c_below_min, true)}</span>}
            <span className="proposed">{parseNumCheckNull(rowDataObj.p_below_min, true)}</span>
          </div>
        </AdvancedCell>
        <AdvancedCell
          getCellProps={hasProps ? rowData?.cells[4].getCellProps : null}
          className="sma--table__body-cell right-align"
        >
          <div className="current-proposed__container">
            {!isNew && <span className="current">{parseNumCheckNull(rowDataObj.c_above_max, true)}</span>}
            <span className="proposed">{parseNumCheckNull(rowDataObj.p_above_max, true)}</span>
          </div>
        </AdvancedCell>
        <AdvancedCell
          getCellProps={hasProps ? rowData?.cells[5].getCellProps : null}
          className="sma--table__body-cell right-align"
        >
          <div className="current-proposed__container">
            {!isNew && (
              <span className="current">
                {parseNumCheckNull(applyRounding(rowDataObj.c_cost_to_move_min, 'monetary', preferences))}
              </span>
            )}
            <span className="proposed">
              {parseNumCheckNull(applyRounding(rowDataObj.p_cost_to_move_min, 'monetary', preferences))}
            </span>
          </div>
        </AdvancedCell>
        <AdvancedCell
          getCellProps={hasProps ? rowData?.cells[6].getCellProps : null}
          className="sma--table__body-cell right-align"
        >
          <div className="current-proposed__container">
            {!isNew && (
              <span className="current">
                {applyRounding(rowDataObj.c_avg_comp_ratio * 100, 'percent', preferences)}
              </span>
            )}
            <span className="proposed">{applyRounding(rowDataObj.p_avg_comp_ratio * 100, 'percent', preferences)}</span>
          </div>
        </AdvancedCell>
        <AdvancedCell
          getCellProps={hasProps ? rowData?.cells[7].getCellProps : null}
          className="sma--table__body-cell right-align"
        >
          <div className="current-proposed__container">
            {!isNew && (
              <span className="current">{applyRounding(rowDataObj.c_avg_range_pen * 100, 'percent', preferences)}</span>
            )}
            <span className="proposed">{applyRounding(rowDataObj.p_avg_range_pen * 100, 'percent', preferences)}</span>
          </div>
        </AdvancedCell>
      </React.Fragment>
    );
  }

  onRowClick = rowData => {
    if (this.props.clickGrade)
      this.props.clickGrade(
        this.props.modelId,
        rowData.original,
        rowData.index,
        this.props.smaData.length - 1,
        this.props.basis
      );
  };

  render() {
    const { smaData, gradeListLoading, tfootData, isPdf, loadingGrade } = this.props;
    return (
      <div className="sma--table-container">
        <AdvancedTable
          staticTable={true}
          stickyHeader={true}
          useSelectAll={false}
          onRowClick={debounce(this.onRowClick, 500)}
          rowClassName="sma--table__body-row"
          columnHeaders={columnHeaders}
          rowData={smaData}
          summaryData={isPdf && tfootData ? [tfootData] : []}
          tfootClass={'table__footer advanced-table__footer sma--table__footer sticky'}
          getDataRow={this.getRowElement}
          dataLoading={loadingGrade || gradeListLoading}
          noDataText="No Grades in This Structure"
          loadingText={loadingGrade ? 'Loading Clicked Grade...' : 'Loading Grades...'}
          className="sma--table"
          headerClassName="sma--table__header"
          bodyClassName="sma--table__body"
        />
      </div>
    );
  }
}
